import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  leaveList: any;
  leaveStrength: number;
  leaveReportTotal: number;
  employmentType: string;
}

const initialState: AuthState = {
  leaveList: [],
  leaveStrength: 0,
  leaveReportTotal: 0,
  employmentType: ""
};

const leaveListSlice = createSlice({
  name: 'leaveList',
  initialState,
  reducers: {
    setLeaveList: (state, action: PayloadAction<any>) => {
      state.leaveList = action.payload;
    },
    setLeaveStrength: (state, action: PayloadAction<number>) => {
      state.leaveStrength = action.payload;
    },
    setEmploymentType: (state, action: PayloadAction<string>) => {
      state.employmentType = action.payload;
    },
    setLeaveReportTotal: (state, action: PayloadAction<number>) => {
      state.leaveReportTotal = action.payload;
    },
    clearLeaveList: state => {
      state.leaveList = [];
    },
  },
});

export const { setLeaveList, clearLeaveList, setLeaveStrength, setLeaveReportTotal, setEmploymentType } = leaveListSlice.actions;
export default leaveListSlice.reducer;
